// extracted by mini-css-extract-plugin
export const home__articles = "HomeArticlesList-module--home__articles--3mlv3";
export const home__view_more_button = "HomeArticlesList-module--home__view_more_button--zlkAZ";